<div class="container">
    <sh-grid class="searchBar">
        <div columns="2" class="search">
            <span>
                <sh-input-text label='Search' id="searchText" [(value)]="searchWord" (click)="isReset($event)"
                    (keyup)="search($event)">
                </sh-input-text>
            </span>
            <!-- <sh-search  (keyup)="search()" label="Search"></sh-search> -->
        </div>
        <div column="8">
            <sh-accordion id="extensionFilter" label="{{currentApp}}"
                (click)="doprdownExpansions.application=!doprdownExpansions.application"
                [expanded]="doprdownExpansions.application">
                <sh-text class="handSelector" id="extensionCheckbox" *ngFor="let app of applications;"
                    (click)="currentApp=app.name;getUsers(app._id, app.name)" #extensionCheckboxes>{{app.name}}
                </sh-text>
            </sh-accordion>
        </div>
        <div column="4">

        </div>
        <div column="8">
            <sh-button label='Add' *ngIf="isSuperUser" [disabled]="nogroups" onclick="document.querySelector('#addUserModal').visible = true">
            </sh-button>
        </div>
    </sh-grid>
    <div class="user-data-div">
        <sh-grid>
            <div columns="10" class="userData">
                <sh-table freeze>
                    <!-- a table row can be placed in the 'header' slot of the table -->
                    <sh-table-row slot="header">
                        <!-- table-heads are used inside header rows -->
                        <sh-table-head (click)="sortUser('userEmailId')" columns="10">Email</sh-table-head>
                        <sh-table-head (click)="sortUser('name')" columns="6">User Name</sh-table-head>
                        <sh-table-head (click)="sortUser('userGroup')" columns="6">Group</sh-table-head>
                        <sh-table-head columns="4">Actions</sh-table-head>
                    </sh-table-row>
                    <sh-table-row *ngFor="let user of users">
                        <!-- use 'columns', 'col-m' and 'col-s' for defining the span of a cell for diffferent breakpoints -->
                        <sh-table-cell columns="10">{{user.userEmailId}}</sh-table-cell>
                        <sh-table-cell columns="6">{{user.name == null ? "" : user.name}}</sh-table-cell>
                        <sh-table-cell columns="6">
                            {{user.applicationName == undefined ? user.userGroup : user.applicationName | userGroup: appId}}
                        </sh-table-cell>
                        <sh-table-cell columns="4">
                            <div class="display-flex">
                                <sh-icon icon="edit" [disabled]="nogroups" (click)="initModify(user)"></sh-icon>
                                <sh-icon icon="delete" *ngIf="isSuperUser || isAdminUser" [disabled]="nogroups" (click)='deleteConfirmation(user)'>
                                </sh-icon>
                            </div>
                        </sh-table-cell>
                    </sh-table-row>
                    <sh-table-row *ngIf="(users == undefined || users.length == 0) && !noAccessToApplication">
                        <sh-table-cell>No users found!</sh-table-cell>
                    </sh-table-row>
                    <sh-table-row *ngIf="noAccessToApplication">
                        <sh-table-cell>You do not have access to this application!</sh-table-cell>
                    </sh-table-row>
                </sh-table>
            </div>
        </sh-grid>
    </div>
    <sh-modal id="addUserModal" sticky label='Add User' modal-height='340px' modal-width='400px'>
        <div columns="12" class="userGroup">
            <span>
                <sh-input-text label='Email ID' [error]="isMailError" id="userEmailId" [(value)]="user.userEmailId"
                    (focusout)="setAddEmail($event)"></sh-input-text>
            </span>
        </div>
        <div columns="12" class="userGroup">
            <span>
                <sh-input-text label='Name' id='userName' [(value)]='user.name'
                    (focusout)="user.name = $event.target['value']"></sh-input-text>
            </span>
        </div>
        <div columns="12" class="userGroup">
            <sh-accordion id="userLevel" label="{{user.userGroup || 'User Group'}}"
                (click)="doprdownExpansions.addGroup=!doprdownExpansions.addGroup"
                [expanded]="doprdownExpansions.addGroup">
                <ng-container *ngIf="isSuperUser || modifySuperAccess">
                    <sh-text class="handSelector" *ngFor="let group of modifyUserGroups;" (click)="user.userGroup=group">
                        {{group}}</sh-text>
                </ng-container>
            </sh-accordion>
        </div>
        <div class="display-flex" columns="10">
            <sh-button color='secondary' class="actionButtons" label='Cancel' (click)="initialiseUser('addUserModal');">
            </sh-button>
            <sh-button color='Primary' [disabled]='(!user.userEmailId || !user.name || !user.userGroup || isMailError)'
                class="actionButtons" label='Save' (click)="addUser()"></sh-button>
        </div>
    </sh-modal>
    <sh-modal id="delete-confirmation" type='alert' label='Delete User' modal-height='184px' modal-width='450px'>
        <sh-text p>Are you sure you want to delete the user - {{userToDelete.name}}?</sh-text>
        <sh-button color='tertiary' slot='footer' label='Cancel'
            onclick="document.getElementById('delete-confirmation').removeAttribute('visible')" id="cancelDelete">
        </sh-button>
        <sh-button color='tertiary' slot='footer' label='Delete' (click)="deleteUser()" id="deleteEntireAsset">
        </sh-button>

    </sh-modal>
    <sh-modal id="EmailExistsPopup" type='error' label='Error' modal-height='184px' modal-width='450px'>
        <sh-text p>Email id you entered exists</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('EmailExistsPopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>
    <sh-modal id="SuccessPopup" type='Success' label='Success' modal-height='184px' modal-width='450px'>
        <sh-text p>{{apiReturnMessage}}</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('SuccessPopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>
    <sh-modal id="FailurePopup" type='Error' label='Error' modal-height='184px' modal-width='450px'>
        <sh-text p>{{apiReturnMessage}}</sh-text>
        <sh-button color='tertiary' slot='footer' label='OK'
            onclick="document.getElementById('FailurePopup').removeAttribute('visible')">
        </sh-button>
    </sh-modal>

    <sh-modal id="modifyUser" sticky label="Modify User" modal-height='340px' modal-width='400px'>
        <div columns="12" class="userGroup">
            <span>
                <sh-input-text disabled label='Email ID' id="userEmailId" [(value)]="user.userEmailId"
                    (focusout)="user.userEmailId=$event.target['value']"></sh-input-text>
            </span>
        </div>
        <div columns="12" class="userGroup">
            <span>
                <sh-input-text disabled label='Name' id='userName' [(value)]='user.name'
                    (focusout)="user.name = $event.target['value']"></sh-input-text>
            </span>
        </div>
        <div columns="12" class="userGroup">
            <sh-accordion id="userLevel" label="{{user.userGroup || 'User Group'}}"
                (click)="doprdownExpansions.addGroup=!doprdownExpansions.addGroup"
                [expanded]="doprdownExpansions.addGroup">
                <sh-text class="handSelector" *ngIf="isAdminUser" (click)="user.userGroup=superUserGroup">
                    {{superUserGroup}}</sh-text>
                <ng-container *ngIf="isAdminUser || isSuperUser || modifySuperAccess">
                    <sh-text class="handSelector" *ngFor="let group of modifyUserGroups;"
                        (click)="user.userGroup=group">{{group}}</sh-text>
                </ng-container>
            </sh-accordion>
        </div>
        <div class="display-flex" columns="10">
            <sh-button color='secondary' class="actionButtons" label='Cancel' (click)="initialiseUser('modifyUser');">
            </sh-button>
            <sh-button color='Primary' [disabled]='(!user.userEmailId || disableSave(user, appId))'
                class="actionButtons" label='Save' (click)="modifyUser()"></sh-button>
        </div>
    </sh-modal>

    <sh-notifications class="mu-notify">
        <sh-notification-item  [visible]="isShowNotificationAlert" 
          type="alert"
          label="Alert">
          {{showAlertMessage}}
        </sh-notification-item>
    </sh-notifications>
</div>